/**
 * Kaido PDP / multi-root countdown — mirrors Hero V3 countdown branches
 * (get_active_bonus_window, get_daily_bonus_products, raffle end_date fallback).
 * Each instance: root #KaidoPdpCountdown-{sectionId} + JSON #KaidoPdpCountdownCfg-{sectionId}
 */
(function () {
  'use strict';

  var CFG_PREFIX = 'KaidoPdpCountdownCfg-';

  function authHeaders(key) {
    return {
      apikey: key,
      Authorization: 'Bearer ' + key,
      'Content-Type': 'application/json',
    };
  }

  function resolveRaffleId(url, key, fallback, auto, cb) {
    if (!auto || !url || !key) {
      cb(fallback || null);
      return;
    }
    fetch(url + '/functions/v1/get_customer_entries/raffle_picker', { headers: authHeaders(key) })
      .then(function (res) {
        if (!res.ok) throw new Error();
        return res.json();
      })
      .then(function (data) {
        var list = Array.isArray(data) ? data : data ? [data] : [];
        var active = null;
        for (var i = 0; i < list.length; i++) {
          if (list[i].status === 'active') {
            active = list[i];
            break;
          }
        }
        if (!active && list.length) active = list[0];
        var id = active && active.id ? active.id : null;
        cb(id || fallback || null);
      })
      .catch(function () {
        cb(fallback || null);
      });
  }

  function initCountdownForSection(sid, cfg) {
    var sectionRoot = document.getElementById('KaidoPdpCountdown-' + sid);
    if (!sectionRoot) return;

    var container = document.getElementById('kpdpCountdownInner-' + sid);
    if (!container) return;

    var PHASE = cfg.phase || 'active';
    var USE_SUPABASE = !!cfg.use_supabase;
    var SUPABASE_URL = cfg.supabase_url || '';
    var SUPABASE_KEY = cfg.supabase_key || '';
    var FALLBACK_RAFFLE_ID = cfg.fallback_raffle_id || '';
    var AUTO_RAFFLE = cfg.auto_raffle !== false;
    var MANUAL_END = cfg.manual_end || '';
    var USE_BONUS_MODE = !!cfg.bonus_mode;
    var SHOW_DAILY_BONUS_MODE = !!cfg.show_daily_bonus;
    var HIDE_WHEN_ENDED = !!cfg.hide_when_ended;
    var PRODUCT_ID = cfg.product_id ? String(cfg.product_id) : '';

    var daysEl = container.querySelector('[data-kh3-days]');
    var hoursEl = container.querySelector('[data-kh3-hours]');
    var minsEl = container.querySelector('[data-kh3-mins]');
    var secsEl = container.querySelector('[data-kh3-secs]');
    if (!daysEl || !hoursEl || !minsEl || !secsEl) return;

    var intervalId = null;

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function updateCountdown(endDate) {
      var now = window.KaidoPublicSnapshot && USE_SUPABASE ? window.KaidoPublicSnapshot.now() : Date.now();
      var end = new Date(endDate).getTime();
      if (isNaN(end)) {
        container.style.display = 'none';
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        return;
      }
      var diff = end - now;
      if (diff <= 0) {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        if (HIDE_WHEN_ENDED) {
          container.style.display = 'none';
        } else {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minsEl.textContent = '00';
          secsEl.textContent = '00';
        }
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(mins);
      secsEl.textContent = pad(secs);
    }

    function tryManual() {
      if (!MANUAL_END) {
        container.style.display = 'none';
        return;
      }
      updateCountdown(MANUAL_END);
      intervalId = setInterval(function () {
        updateCountdown(MANUAL_END);
      }, 1000);
    }

    function setCountdownLabel(text) {
      var labelEl = sectionRoot.querySelector('.kpdp-countdown__head');
      if (!labelEl) return;
      labelEl.textContent = text;
    }

    function startCountdownTo(isoDate) {
      if (intervalId) clearInterval(intervalId);
      container.style.display = '';
      updateCountdown(isoDate);
      intervalId = setInterval(function () {
        updateCountdown(isoDate);
      }, 1000);
    }

    var useSb = USE_SUPABASE && SUPABASE_URL && SUPABASE_KEY && PHASE === 'active';
    var useBonusModeAnyPhase = USE_SUPABASE && USE_BONUS_MODE && SUPABASE_URL && SUPABASE_KEY;

    if (window.KaidoPublicSnapshot && USE_SUPABASE) {
      var api = window.KaidoPublicSnapshot;
      function updateProjection() {
        if (intervalId) { clearInterval(intervalId); intervalId = null; }
        var data = api.get(), time = api.now();
        sectionRoot.classList.remove('kpdp-countdown-banner--bonus-active');
        if (!data || !api.active()) { sectionRoot.style.display = 'none'; return; }
        sectionRoot.style.display = '';
        if (USE_BONUS_MODE && SHOW_DAILY_BONUS_MODE) {
          var daily = data.daily;
          if (!daily || !daily.enabled || Date.parse(daily.starts_at) > time || Date.parse(daily.ends_at) <= time) {
            sectionRoot.style.display = 'none'; return;
          }
          var onBonus = daily.products.some(function (row) { return row.product_id === PRODUCT_ID; });
          setCountdownLabel(onBonus ? "THIS PRODUCT\u2019S BONUS ENDS IN" : 'BONUS ENTRIES END IN');
          sectionRoot.classList.toggle('kpdp-countdown-banner--bonus-active', onBonus);
          startCountdownTo(daily.ends_at);
        } else {
          setCountdownLabel('THE GIVEAWAY ENDS IN'); startCountdownTo(data.raffle.ends_at);
        }
      }
      api.ready.then(updateProjection);
      document.addEventListener('kaido:public-snapshot', updateProjection);
      return;
    }

    if (useBonusModeAnyPhase && SHOW_DAILY_BONUS_MODE) {
      var bonusUrl = SUPABASE_URL + '/functions/v1/get_active_bonus_window';
      var bonusHeaders = { apikey: SUPABASE_KEY, 'Content-Type': 'application/json' };
      var dailyBonusUrl = SUPABASE_URL + '/functions/v1/get_daily_bonus_products';
      Promise.all([
        fetch(bonusUrl, { headers: bonusHeaders }).then(function (res) {
          if (!res.ok) {
            if (res.status === 404) return null;
            throw new Error('HTTP ' + res.status);
          }
          return res.json();
        }),
        fetch(dailyBonusUrl, { headers: bonusHeaders })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .catch(function () {
            return null;
          }),
      ])
        .then(function (results) {
          var data = results[0];
          var dailyBonus = results[1] || { active: false };
          // PDP banner is daily-bonus-only — hide entirely if no active daily bonus
          if (!dailyBonus.active || !dailyBonus.expires_at) {
            sectionRoot.style.display = 'none';
            return;
          }
          if (!data) {
            sectionRoot.style.display = 'none';
            return;
          }
          // Daily bonus is active — show the banner
          var thisProductOnBonus = PRODUCT_ID && Array.isArray(dailyBonus.products) &&
            dailyBonus.products.some(function(p) { return String(p.shopify_product_id) === PRODUCT_ID; });
          if (thisProductOnBonus) {
            setCountdownLabel("THIS PRODUCT\u2019S BONUS ENDS IN");
            sectionRoot.classList.add('kpdp-countdown-banner--bonus-active');
          } else {
            setCountdownLabel('BONUS ENTRIES END IN');
          }
          startCountdownTo(dailyBonus.expires_at);
        })
        .catch(function () {
          // Fetch failed — hide the banner entirely
          sectionRoot.style.display = 'none';
        });
      return;
    }

    if (useSb) {
      resolveRaffleId(SUPABASE_URL, SUPABASE_KEY, FALLBACK_RAFFLE_ID, AUTO_RAFFLE, function (raffleId) {
        if (!raffleId) {
          tryManual();
          return;
        }
        var url =
          SUPABASE_URL +
          '/rest/v1/raffles?id=eq.' +
          encodeURIComponent(raffleId) +
          '&select=end_date';
        fetch(url, { headers: authHeaders(SUPABASE_KEY) })
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function (data) {
            if (!Array.isArray(data) || !data[0] || !data[0].end_date) {
              tryManual();
              return;
            }
            setCountdownLabel('THE GIVEAWAY ENDS IN');
            startCountdownTo(data[0].end_date);
          })
          .catch(function () {
            tryManual();
          });
      });
      return;
    }

    tryManual();
  }

  function boot() {
    var nodes = document.querySelectorAll('script[type="application/json"][id^="' + CFG_PREFIX + '"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var sid = el.id.slice(CFG_PREFIX.length);
      var cfg;
      try {
        cfg = JSON.parse(el.textContent || '{}');
      } catch (e) {
        continue;
      }
      if (cfg && cfg.enabled !== false) initCountdownForSection(sid, cfg);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
